import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { getAllDisputes } from "../../../../../api/order/disputes-admin";
import AppLayout from "../../../../../layout/DashboardLayout";
import adminIndex from "../../../components/adminIndex.module.css";
import { orderSelector } from "../../../../../redux/slices/orderSlice";
import styles from "../../../../customer/styles/customerStyles.module.css";
import DisputeTabs from "./components/DisputeTabs";
import { getAllDisputes } from "../../../../../api/order";

function DisputeList() {
  const { disputeInfo, isLoading } = useSelector(orderSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllDisputes({ page: 0, size: 50 }));
  }, []);

  return (
    <AppLayout background="#f1f1f1">
      <div className={adminIndex.page}>
      <div className={styles.dispute_list}>
        <div className={adminIndex.header}>
          <h1 className={adminIndex.title}>Disputes</h1>
        </div>

        {/* tab section */}
        <DisputeTabs
          disputeInfo={disputeInfo}
          pendingDisputeInfo={disputeInfo?.disputes?.filter((dispute) => dispute.status === "pending")}
          deliveredDisputeInfo={disputeInfo?.disputes?.filter((dispute) => dispute.status === "complete")}
          loading={isLoading}
        />
      </div>
      </div>
    </AppLayout>
  );
}
export default DisputeList
